import i18n from '@/i18n'

type AppLanguage = 'zh' | 'en'

type ViewTextMessages = Record<string, string>

interface LocaleMessage {
  viewsText?: ViewTextMessages
}

export function tv(text: string): string {
  const locale = i18n.global.locale.value as AppLanguage
  const messages = i18n.global.getLocaleMessage(locale) as LocaleMessage
  return messages.viewsText?.[text] ?? text
}
